module.exports = __webpack_public_path__ + "static/media/creatorCards-mobile.6f5fb269.png";